<template>
  <a-breadcrumb v-if="!isMobile" class="breadcurmb-wrap">
    <a-breadcrumb-item
      v-for="(route, index) of $route.matched"
      :key="index"
      :href="route.path"
      @click.native="handleBreadcrumb(route)"
      >{{ route.meta.title }}</a-breadcrumb-item
    >
  </a-breadcrumb>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isMobile"])
  },
  methods: {
    handleBreadcrumb(route) {
      const { redirect, path } = route;
      if (redirect) {
        this.$router.push(redirect);
      } else if (path === "") {
        this.$router.push("/");
      } else if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.breadcurmb-wrap {
  margin-left: 20px;
}
</style>
